const ALIGN = 'center'
export const BASIC_DATA = [
  {
    title: '起量功能',
    key: 'materialRaise',
    overflow: true,
    width: 120,
    exclude_export: true
  },

  {
    title: '一键起量',
    key: 'raiseStatus',
    align: ALIGN,
    overflow: true,
    width: 84,
    exclude_export: true
  },
  {
    title: '状态',
    key: 'mediaStatus',
    width: 80,
    // overflow: true,
    exclude_export: true
  },
  {
    title: '项目/组预算',
    key: 'projectDayBudget',
    width: 120,
    overflow: false,
    exclude_export: true
  },
  {
    title: '计划预算',
    key: 'budget',
    align: ALIGN,
    width: 60,
    exclude_export: true
  },

  {
    title: '项目/组目标出价',
    key: 'projectTargetBid',
    align: ALIGN,
    width: 60,
    exclude_export: true
  },

  {
    title: '项目/组深度目标出价',
    key: 'projectDeepBid',
    align: ALIGN,
    width: 60,
    exclude_export: true
  },
  {
    title: '项目/组ROI出价',
    key: 'projectRoi',
    align: ALIGN,
    width: 60,
    exclude_export: true
  },

  {
    title: '计划目标出价',
    key: 'bid',
    align: ALIGN,
    width: 60,
    exclude_export: true
  },
  {
    title: '计划深度目标出价',
    key: 'deepCpabid',
    align: ALIGN,
    width: 65,
    exclude_export: true
  },
  {
    title: '计划ROI出价',
    key: 'roiRatio',
    align: ALIGN,
    width: 60,
    exclude_export: true
  },

  {
    title: '项目组',
    key: 'projectGroupName',
    overflow: true,
    width: 72,
    exclude_export: true
  },
  {
    title: '投放媒体',
    key: 'mediaName',
    overflow: true,
    width: 78
  },
  {
    title: '投放位',
    key: 'advertPosiName',
    width: 84,
    overflow: true
  },
  {
    title: '优化目标',
    key: 'optimizationTypeName',
    overflow: true,
    width: 60
  },
  {
    title: '深度优化',
    key: 'deepOptimizationTypeName',
    overflow: true,
    width: 60
  },
  {
    title: '投放游戏',
    key: 'productName',
    width: 86,
    overflow: true
  },
  {
    title: '投放账号',
    key: 'adAccountName',
    width: 77,
    overflow: true
  },
  {
    title: '投放人',
    key: 'name',
    width: 60,
    overflow: true
  },
  {
    title: '素材（老）',
    key: 'imageName',
    width: 70,
    overflow: true
  },

  {
    title: '多素材（新）',
    key: 'imageDetailNames',
    width: 70,
    overflow: true,
    exclude_export: true
  },
  {
    title: '落地页ID',
    key: 'pageId',
    overflow: true,
    width: 60
  },
  {
    title: '是否监测',
    key: 'isMonitor',
    overflow: true,
    width: 37
  },
  {
    title: '代投',
    key: 'proxyAccountName',
    overflow: true,
    width: 35
  },
  {
    title: '新建时间',
    key: 'launchTime',
    sortable: 'custom',
    width: 84
  },
  {
    title: '计划ID',
    key: 'planId',
    width: 58
  },
  {
    title: '回调优化比例',
    key: 'deductRate',
    width: 48
  },
  {
    title: '媒体计划ID',
    key: 'mediaPlanId',
    width: 48
  }
].map((i) => ({ ...i, checked: true }))

export const REPORT_DATA = [
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },
  {
    title: '赠款消耗',
    key: 'giveAmount',
    align: ALIGN,
    width: 68
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },
  {
    title: '曝光量',
    key: 'pv',
    sortable: 'custom',
    align: ALIGN,
    width: 71
  },
  {
    title: '采集点击数',
    key: 'collectClickNum',
    align: ALIGN,
    width: 72
  },
  {
    title: '收益展示次数',
    key: 'profitPv',
    align: ALIGN,
    width: 72
  },
  {
    title: '下载率',
    key: 'downRate',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '千次曝光成本',
    key: 'qcPvCost',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '变现计划曝光量',
    key: 'adExposureCount',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },

  {
    title: '计划变现人数',
    key: 'watchFinishUserNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },

  {
    title: '计划变现次数',
    key: 'watchFinishCount',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },

  {
    title: '计划变现人均次数',
    key: 'watchFinishAvgCount',
    sortable: 'custom',
    align: ALIGN,
    width: 78
  },

  {
    title: '首日广告变现收入',
    key: 'monetizationAmount24h',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '3日广告变现收入',
    key: 'monetizationAmount3d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日广告变现收入',
    key: 'monetizationAmount7d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日广告变现ROI',
    key: 'monetizationRoi24h',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '3日广告变现ROI',
    key: 'monetizationRoi3d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日广告变现ROI',
    key: 'monetizationRoi7d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '广告变现人数',
    key: 'adMonetizationUserCount',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '广告变现次数',
    key: 'adMonetizationCount',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '广告变现人均次数',
    key: 'adMonetizationAvgCount',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },
  {
    title: '已投天数',
    key: 'launchDays',
    sortable: 'custom',
    align: ALIGN,
    width: 50
  },
  {
    title: '激活数',
    key: 'downNum',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '注册数',
    key: 'newUserNum',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    align: ALIGN,
    width: 58
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    align: ALIGN,
    width: 58
  },
  {
    title: '激活转化率',
    key: 'activeRate',
    align: ALIGN,
    width: 50
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    align: ALIGN,
    width: 60
  },
  {
    title: '首日二次付费率',
    key: 'createRolePayTwiceRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '首日等级通过率',
    key: 'roleLevelReachNumRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角1小时内等级通过率',
    key: 'roleLevelReachOneHourRate',
    sortable: 'custom',
    align: ALIGN,
    width: 152
  },
  {
    title: '首日付费创角数',
    key: 'payRole1d',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角付费次数',
    key: 'newRolePayCnt',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '每次付费成本',
    key: 'newRolePayCntCost',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新增付费创角数',
    key: 'payRoleUserNum',
    sortable: 'custom',
    align: ALIGN,
    width: 75
  },
  {
    title: '创角付费成本',
    key: 'newPayCost',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '当日付费设备',
    key: 'payActiveDeviceNum',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新设备付费率',
    key: 'payActiveDeviceNumRate',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新设备充值',
    key: 'newDeviceMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新创角充值',
    key: 'newRoleMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '总流水',
    key: 'sumMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角24小时付费金额',
    key: 'createRole24hPayMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角24小时ROI',
    key: 'createRole24hRoi',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角24小时付费次数',
    key: 'createRole24hPayCount',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角24小时安卓付费金额',
    key: 'createRole24hAndroidMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '创角24小时IOS付费金额',
    key: 'createRole24hIosMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '创角24小时分成后ROI',
    key: 'createRole24hAdjustedRoi',
    sortable: 'custom',
    align: ALIGN,
    width: 75
  },
  {
    title: '转端流水',
    key: 'transMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新设备回款率',
    key: 'newDeviceRate',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },

  {
    title: '表单预约量',
    key: 'eventAppointForm',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },

  {
    title: '预约跳转点击',
    key: 'eventAppointJumpClick',
    sortable: 'custom',
    align: ALIGN,
    width: 75
  },
  {
    title: '表单预约成本',
    key: 'eventAppointFormCost',
    sortable: 'custom',
    align: ALIGN,
    width: 75
  },

  {
    title: '预约跳转点击成本',
    key: 'eventAppointJumpClickCost',
    sortable: 'custom',
    align: ALIGN,
    width: 85
  },

  {
    title: '表单预约人数',
    key: 'reservationUv',
    sortable: 'custom',
    align: ALIGN,
    width: 75
  },

  {
    title: '表单预约成本（人数）',
    key: 'reservationUvCost',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },

  {
    title: '转化数',
    key: 'convertNum',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },

  {
    title: '转化成本',
    key: 'convertCost',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },

  {
    title: '7日付费次数',
    key: 'newRoleSevenDayPayCnt',
    sortable: 'custom',
    align: ALIGN,
    width: 88
  },

  {
    title: '7日每次付费成本',
    key: 'newRoleSevenDayPayCntCost',
    sortable: 'custom',
    align: ALIGN,
    width: 88
  }
].map((i) => ({ ...i, checked: true }))

export const RETAIN_DATA = [
  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活1日LTV',
    key: 'oneDayLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活3日LTV',
    key: 'threeDayLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活7日LTV',
    key: 'sevenDayLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活30日LTV',
    key: 'thirtyDayLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角次留',
    key: 'twoDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角3留',
    key: 'threeDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角4留',
    key: 'fourDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角5留',
    key: 'fiveDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角6留',
    key: 'sixDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角7留',
    key: 'sevenDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角10留',
    key: 'tenDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角15留',
    key: 'fifteenDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角30留',
    key: 'thirtyDayCreateRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角1日LTV',
    key: 'oneDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角2日LTV',
    key: 'twoDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角3日LTV',
    key: 'threeDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角4日LTV',
    key: 'fourDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角5日LTV',
    key: 'fiveDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角6日LTV',
    key: 'sixDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角7日LTV',
    key: 'sevenDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角10日LTV',
    key: 'tenDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角15日LTV',
    key: 'fifteenDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角30日LTV',
    key: 'thirtyDayCreateLtv',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费次留',
    key: 'twoDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费3留',
    key: 'threeDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费4留',
    key: 'fourDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费5留',
    key: 'fiveDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费6留',
    key: 'sixDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费7留',
    key: 'sevenDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费10留',
    key: 'tenDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费15留',
    key: 'fifteenDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角付费30留',
    key: 'thirtyDayNewPayRoleRetain',
    align: ALIGN,
    width: 60
  },
  {
    title: '1日ROI',
    key: 'firstDayRoi',
    align: ALIGN,
    width: 60
  },
  {
    title: '3日ROI',
    key: 'threeDayRoi',
    align: ALIGN,
    width: 60
  },
  {
    title: '7日ROI',
    key: 'sevenDayRoi',
    align: ALIGN,
    width: 60
  }
].map((i) => ({ ...i, checked: true }))

export const MID_REPORT_DATA = [
  {
    title: '激活数_中间件',
    key: 'mDownNum',
    align: ALIGN,
    sortable: 'custom',
    width: 80
  },
  {
    title: '创角数_中间件',
    key: 'mCreateRoleNum',
    align: ALIGN,
    sortable: 'custom',
    width: 80
  },
  {
    title: '创角成本_中间件',
    key: 'mCreateRoleCost',
    align: ALIGN,
    sortable: 'custom',
    width: 80
  },
  {
    title: '首日付费创角数_中间件',
    key: 'mDay1PayRole',
    align: ALIGN,
    sortable: 'custom',
    width: 100
  },
  {
    title: '首日付费创角成本_中间件',
    key: 'mDay1PayRoleCost',
    align: ALIGN,
    sortable: 'custom',
    width: 100
  },
  {
    title: '首日创角付费次数_中间件',
    key: 'mDay1RolePayCnt',
    align: ALIGN,
    sortable: 'custom',
    width: 100
  },
  {
    title: '首日每次创角付费成本_中间件',
    key: 'mDay1RolePayPerCost',
    align: ALIGN,
    sortable: 'custom',
    width: 120
  },
  {
    title: '首日创角充值_中间件',
    key: 'mDay1RoleRecharge',
    align: ALIGN,
    sortable: 'custom',
    width: 100
  },
  {
    title: '首日创角ROI_中间件',
    key: 'mDay1RoleRoi',
    align: ALIGN,
    sortable: 'custom',
    width: 100
  }
].map((i) => ({ ...i, checked: true }))
export const FIXED_DATA = [
  {
    title: '开关',
    key: 'switch',
    width: 40,
    fixed: true,
    exclude_export: true
  },
  {
    title: '投放计划名称',
    key: 'planName',
    fixed: true,
    width: 140,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    fixed: true,
    width: 150,
    exclude_export: true
  }
]

export default {
  BASIC_DATA,
  REPORT_DATA,
  RETAIN_DATA,
  MID_REPORT_DATA
}

export const NAVS = [
  {
    label: '基础信息',
    key: '1',
    children: [
      {
        label: '基础信息',
        key: 'BASIC_DATA'
      }
    ]
  },
  {
    label: '报表数据',
    key: '2',
    children: [
      {
        label: '报表数据',
        key: 'REPORT_DATA'
      }
    ]
  },
  {
    label: '留存数据',
    key: '3',
    children: [
      {
        label: '留存数据',
        key: 'RETAIN_DATA'
      }
    ]
  },
  {
    label: '中间件',
    key: '4',
    children: [
      {
        label: '报表数据',
        key: 'MID_REPORT_DATA'
      }
    ]
  }
]
